<template>
  <div class="about-page">
    <!-- 標題區塊 -->
    <section class="hero-section">
      <div class="hero-content">
        <h1 class="hero-title">關於長發地產 Chang Fa Real Estate</h1>
        <p class="hero-slogan">長發致遠 · 地產風華</p>
      </div>
    </section>

    <!-- 核心理念區塊 -->
    <section class="core-section container">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="core-content">
            <h3 class="section-title">我們的核心</h3>
            <p class="core-text">
              長發地產，以<strong>「專業誠信、共創長遠」</strong>為經營核心，深耕房地產市場多年，專注於<br>
              👉 <span class="highlight">土地買賣仲介、土地整合、合建媒合、都市更新與危老重建</span> 等領域。
            </p>
            <p class="core-text">
              我們以專業視野洞察土地價值，以策略整合創造共榮契機，<br>
              協助地主、建商及投資人之間的資源鏈結，<br>
              將潛藏的土地潛力轉化為城市的嶄新風貌。
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- 服務項目卡片 -->
    <section class="services-section">
      <div class="container">
        <h3 class="section-title text-center mb-5">服務項目</h3>
        <div class="row g-4">
          <div class="col-md-6 col-lg-3">
            <div class="service-card">
              <div class="service-icon">🏘️</div>
              <h4>土地買賣仲介</h4>
              <p>專業評估，精準媒合</p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="service-card">
              <div class="service-icon">🤝</div>
              <h4>土地整合</h4>
              <p>策略整合，創造價值</p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="service-card">
              <div class="service-icon">🏗️</div>
              <h4>合建媒合</h4>
              <p>資源鏈結，共創雙贏</p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="service-card">
              <div class="service-icon">🏙️</div>
              <h4>都更危老重建</h4>
              <p>城市新生，永續發展</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 專業能力區塊 -->
    <section class="capabilities-section">
      <div class="container">
        <h3 class="section-title text-center mb-5">專業能力</h3>
        <div class="row g-4">
          <div class="col-md-6 col-lg-3">
            <div class="service-card">
              <div class="service-icon">🎯</div>
              <h4>專業視野</h4>
              <p>洞察土地價值，發掘潛力商機</p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="service-card">
              <div class="service-icon">🤝</div>
              <h4>誠信至上</h4>
              <p>以誠信為基石，建立長久信賴</p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="service-card">
              <div class="service-icon">⚡</div>
              <h4>高效執行</h4>
              <p>以效率為動力，快速達成目標</p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="service-card">
              <div class="service-icon">🔭</div>
              <h4>遠見卓識</h4>
              <p>以遠見為方向，築建未來榮景</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 願景使命區塊 -->
    <section class="vision-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <div class="vision-card">
              <div class="vision-content">
                <p class="vision-text">
                  在每一塊土地的背後，我們看到的不只是交易，<strong>更是一座城市的未來藍圖</strong>。
                </p>
                <p class="vision-text">
                  長發地產堅持以<strong>誠信為基石、以效率為動力、以遠見為方向</strong>，<br>
                  整合資源、串聯價值，實現從「土地」到「風華」的轉化。
                </p>
                <div class="divider"></div>
                <h3 class="vision-title">長發致遠，地產風華</h3>
                <p class="vision-text">
                  我們相信，唯有<strong>長久發展的信念與遠見</strong>，<br>
                  才能築出一座又一座值得世代傳承的榮景。
                </p>
                <p class="vision-text">
                  秉持<strong>專業、誠信與共榮</strong>的精神，<br>
                  長發地產將持續與夥伴並肩前行，<br>
                  以行動實踐願景，打造永續繁榮的城市未來。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 圖片展示區 -->
    <section class="gallery-section container">
      <div class="row g-4">
        <div class="col-md-6">
          <div class="gallery-item">
            <img src="/長發辦公室.jpg" alt="長發地產專業辦公室 - 提供桃園土地開發與重劃諮詢服務" class="img-fluid rounded shadow" loading="lazy" />
            <div class="gallery-caption">專業團隊 · 值得信賴</div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="gallery-item">
            <img src="/長發櫃台.jpg" alt="長發地產服務櫃台 - 專業接待區提供土地投資諮詢" class="img-fluid rounded shadow" loading="lazy" />
            <div class="gallery-caption">深耕在地 · 永續發展</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head';

export default {
  name: 'AboutPage',
  setup() {
    useHead({
      title: '關於長發地產 | 專業誠信、共創長遠 - 北台灣土地開發整合領導品牌',
      meta: [
        {
          name: 'description',
          content: '長發地產以專業誠信為核心，深耕房地產市場，專注土地買賣仲介、土地整合、合建媒合、都市更新與危老重建。協助地主、建商及投資人之間的資源鏈結，將潛藏的土地潛力轉化為城市的嶄新風貌。'
        },
        {
          name: 'keywords',
          content: '長發地產,關於我們,公司介紹,土地買賣仲介,土地整合,合建媒合,都市更新,危老重建,專業誠信,房地產,桃園'
        },
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: '關於長發地產 | 專業誠信、共創長遠' },
        { property: 'og:description', content: '長發地產深耕房地產市場，專注土地開發整合、都市更新與危老重建' },
        { property: 'og:image', content: '/長發外觀.jpg' },
        { name: 'twitter:card', content: 'summary_large_image' }
      ],
      script: [
        {
          type: 'application/ld+json',
          children: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '關於長發地產',
            description: '長發地產以專業誠信為核心，專注土地開發整合服務',
            mainEntity: {
              '@type': 'Organization',
              name: '長發地產',
              url: 'https://changfarealestate.com.tw',
              logo: '/長發外觀.jpg',
              foundingDate: '2025',
              address: {
                '@type': 'PostalAddress',
                addressCountry: 'TW',
                addressRegion: '桃園市'
              }
            }
          })
        }
      ]
    });
  }
}
</script>

<style scoped>
.about-page {
  min-height: 100vh;
  background: #fff;
  padding-top: 80px;
}

/* Hero Section */
.hero-section {
  position: relative;
  background: #fff;
  padding: 50px 20px 30px;
  text-align: center;
  color: #333;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 900px;
  margin: 0 auto;
}

.hero-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #333;
  animation: fadeInDown 0.8s ease-out;
}

.hero-slogan {
  font-size: 1.8rem;
  font-weight: 500;
  letter-spacing: 3px;
  color: #666;
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

/* Section Title */
.section-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 30px;
  position: relative;
  display: block;
  text-align: center;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 2px;
}

/* Core Section */
.core-section {
  padding: 80px 20px;
  text-align: center;
}

.core-content {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 60px 50px;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.1);
}

.core-text {
  font-size: 1.2rem;
  line-height: 2;
  color: #333;
  margin-bottom: 30px;
}

.highlight {
  color: #764ba2;
  font-weight: 600;
}

/* Services Section */
.services-section {
  padding: 80px 20px;
  background: #f8f9fa;
}

/* Capabilities Section */
.capabilities-section {
  padding: 40px 20px 80px;
  background: #f8f9fa;
}

.service-card {
  background: white;
  padding: 40px 30px;
  border-radius: 15px;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(0,0,0,0.08);
  height: 100%;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(102, 126, 234, 0.2);
}

.service-icon {
  font-size: 3.5rem;
  margin-bottom: 20px;
}

.service-card h4 {
  font-size: 1.4rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.service-card p {
  color: #666;
  font-size: 1rem;
  margin: 0;
}

/* Vision Section */
.vision-section {
  padding: 80px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.vision-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 50px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.vision-content {
  text-align: center;
}

.quote-icon {
  font-size: 4rem;
  margin-bottom: 30px;
}

.vision-text {
  font-size: 1.3rem;
  line-height: 2;
  margin-bottom: 30px;
}

.vision-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #fff;
  margin: 30px 0;
  text-shadow: 0 2px 10px rgba(0,0,0,0.2);
}

.divider {
  width: 80px;
  height: 3px;
  background: rgba(255, 255, 255, 0.5);
  margin: 40px auto;
  border-radius: 2px;
}

/* Gallery Section */
.gallery-section {
  padding: 80px 20px 120px;
}

.gallery-item {
  position: relative;
  overflow: hidden;
  border-radius: 15px;
  transition: all 0.3s ease;
}

.gallery-item:hover {
  transform: scale(1.02);
}

.gallery-item img {
  width: 100%;
  height: 400px;
  object-fit: cover;
  transition: all 0.3s ease;
}

.gallery-item:hover img {
  transform: scale(1.05);
}

.gallery-caption {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 100%);
  color: white;
  padding: 30px 20px 20px;
  font-size: 1.2rem;
  font-weight: 600;
}

/* Animations */
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 響應式設計 */
@media (max-width: 992px) {
  .hero-title {
    font-size: 2rem;
  }
  
  .hero-slogan {
    font-size: 1.4rem;
  }
  
  .section-title {
    font-size: 1.8rem;
  }
  
  .core-content {
    padding: 40px 30px;
  }
  
  .core-text {
    font-size: 1.1rem;
  }
}

@media (max-width: 768px) {
  .about-page {
    padding-top: 70px;
  }
  
  .hero-section {
    padding: 40px 20px 30px;
  }
  
  .hero-title {
    font-size: 1.6rem;
  }
  
  .hero-slogan {
    font-size: 1.2rem;
    letter-spacing: 2px;
  }
  
  .core-section,
  .services-section,
  .vision-section,
  .gallery-section {
    padding: 60px 15px;
  }
  
  .capabilities-section {
    padding: 30px 15px 60px;
  }
  
  .core-content {
    padding: 30px 20px;
  }
  
  .core-text {
    font-size: 1rem;
    line-height: 1.8;
  }
  
  .core-text br {
    display: none;
  }
  
  .service-card {
    padding: 30px 20px;
  }
  
  .vision-card {
    padding: 30px 20px;
  }
  
  .vision-text {
    font-size: 1.1rem;
    line-height: 1.8;
  }
  
  .vision-text br {
    display: none;
  }
  
  .vision-title {
    font-size: 1.8rem;
  }
  
  .gallery-item img {
    height: 300px;
  }
}

@media (max-width: 576px) {
  .hero-title {
    font-size: 1.3rem;
  }
  
  .hero-slogan {
    font-size: 1rem;
  }
  
  .section-title {
    font-size: 1.5rem;
  }
  
  .vision-title {
    font-size: 1.5rem;
  }
  
  .gallery-item img {
    height: 250px;
  }
}
</style>


